import { AssetData } from '@betterfunnel/types';
import { ChevronLeftIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import { classNames } from '../../utils';
import IconButton from '../Common/IconButton';

interface Props {
  images: AssetData[];
  className?: string;
}

export const ImageViewer = ({ images, className }: Props) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const image = images[currentIndex];

  return (
    <div className={classNames('relative', className)}>
      <IconButton
        className="absolute left-4 top-1/2 -translate-y-1/2 transform bg-slate-500 bg-opacity-40 hover:bg-slate-500 hover:bg-opacity-80"
        onClick={() =>
          setCurrentIndex((currentIndex + images.length - 1) % images.length)
        }
      >
        <ChevronLeftIcon className="h-6 w-6" />
      </IconButton>
      <img
        key={image.url}
        src={image.url}
        alt={image.alt}
        className="h-full w-full object-contain"
      />
      <IconButton
        className="absolute right-4 top-1/2 -translate-y-1/2 transform bg-slate-500 bg-opacity-40 hover:bg-slate-500 hover:bg-opacity-80"
        onClick={() => setCurrentIndex((currentIndex + 1) % images.length)}
      >
        <ChevronLeftIcon className="h-6 w-6 rotate-180 transform" />
      </IconButton>
    </div>
  );
};
